<template>
	<div class="post-desc-wrap" @keyup.enter="hello">

    	<div class="post-desc-img">
    	   	<img :src="require(`@/assets/images/posts-img/${posts[activeIndex].img}`)" v-if="activeIndex < posts.length" />
    	   	<img :src="require(`@/assets/images/posts-img/${nextseries.background}`)" v-else />
            <div class="post-desc-navigator">
                <div class="navigator-left" @click="previous"></div>
                <div class="navigator-center" @click="center"></div>
                <div class="navigator-right" @click="next"></div>
            </div>
    	</div>

    	<div class="post-desc-content" v-if="activeIndex < posts.length">
    		<h3 v-show="onboarding">{{ posts[activeIndex].description }}</h3>
    	</div>

    	<div class="next-series" v-else>
    		<div class="next-series-img">
    			<img :src="require(`@/assets/images/posts-img/${nextseries.img}`)"/>
    		</div>
    		<div class="next-series-desc">
    			<h2>Part 2</h2>
    			<p>Tom Riddle Meets Albus Dumbledore</p>
    		</div>
    		<div class="next-series-player">
    			<p>Next part starts in <span>5 seconds</span></p>
    			<div class="play-btn-wrap">
					<radial-progress-bar :diameter="70"
										:strokeWidth="3"
										:innerStrokeWidth="4"
					                    :completed-steps="completedSteps"
					                    startColor="#fff"
					                    stopColor="#fff"
					                    :animateSpeed="5000"
					                    :total-steps="totalSteps">
					  </radial-progress-bar>
	    			<div class="play-btn">
		    			<svg width="23" height="26" xmlns="http://www.w3.org/2000/svg"><path d="M17.856 14.706L4.04 23.143q-.057.034-.115.065-.059.03-.12.058-.06.026-.122.049-.063.023-.126.041-.064.019-.128.033-.065.014-.13.024-.066.01-.132.016-.066.005-.132.007l-.132-.002q-.066-.004-.132-.011-.066-.008-.131-.02-.065-.011-.13-.027-.064-.017-.127-.037-.063-.02-.124-.045-.062-.024-.122-.053-.06-.028-.117-.06-.058-.033-.113-.07-.056-.035-.109-.075-.053-.04-.103-.083-.05-.043-.097-.09-.048-.046-.092-.095-.044-.05-.084-.102-.041-.052-.078-.107-.038-.055-.071-.112-.033-.057-.063-.116-.03-.06-.055-.12-.026-.062-.047-.124-.022-.063-.04-.127-.017-.064-.03-.129-.013-.064-.021-.13-.01-.066-.014-.132T1 21.437V4.563q0-.066.004-.132.005-.066.014-.132.008-.065.021-.13.013-.065.03-.13.018-.063.04-.126.021-.062.047-.123.025-.061.055-.12.03-.06.063-.117.033-.057.07-.112.038-.055.079-.107.04-.052.084-.102.044-.049.092-.095.047-.047.097-.09t.103-.083q.053-.04.109-.076.055-.036.113-.068.058-.033.117-.061.06-.029.122-.053.061-.025.124-.045.063-.02.127-.037.065-.016.13-.028.065-.011.13-.019.067-.007.133-.01.066-.004.132-.003.066.002.132.007.066.006.132.016.065.01.13.024.064.014.128.033.063.018.126.041.062.023.122.05.061.026.12.057.058.03.115.065l13.815 8.437q.054.033.106.07.053.037.103.077.05.04.097.083.047.043.091.089t.086.095q.041.048.08.1.037.051.072.105.035.053.066.109t.06.113q.027.058.05.117.024.06.045.12.02.06.036.123.016.061.028.124t.02.126q.009.064.013.127.004.064.004.128t-.004.128q-.004.063-.012.127l-.02.126q-.013.063-.03.124-.015.062-.035.123-.02.06-.044.12-.024.06-.052.117-.028.057-.059.113-.031.056-.066.11-.035.053-.073.104-.038.052-.08.1-.04.05-.085.095-.044.046-.091.09-.047.042-.097.082t-.103.077q-.052.037-.106.07z" fill="#FFF"/><path d="M21.5 3v20" fill="none" stroke="#FFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
		    		</div>
	    		</div>
    			<button @click="seriescancel">Cancle</button>
    		</div>
    	</div>

    	<div v-show="onboarding" class="progressbar-wrap">
    		<div class="progressbar-inner" :style="{ width: progress + '%'}">
    			<div class="progress-scroll" >
    				<span>{{ activeIndex+1 }} / {{ posts.length+1 }}</span>
    			</div>
    		</div>
    	</div>

        <onboarding v-show="!onboarding"></onboarding>

	</div>
</template>


<script>
	import RadialProgressBar from 'vue-radial-progress'
	import { EventBus } from '../../../main';
	export default {
      	name: "post-details-component",

		data(){
			return {
				nextAutoPlay:true,
				onboarding:false,
			    completedSteps: 0,
			    totalSteps: 10,
		  		activeIndex:0,
		  		progress:0,
			    posts:[
			      	{
			      		img: 'p1.jpeg',
			      		description: 'It was a dark and stormy night and the murder happened.It was a dark and stormy night and the murder happened.It was a dark and stormy night and the murder happened.'
			      	},
			      	{
			      		img: 'p1.jpeg',
			      		description: 'It was a dark and stormy night and the murder happened.It was a dark and stormy night and the murder happened.'
			      	},
			      	{
			      		img: 'p1.jpeg',
			      		description: 'Lorem 3'
			      	},
			      	{
			      		img: 'p1.jpeg',
			      		description: 'Lorem 4'
			      	},
			    ],
			    nextseries:{
			    	background:'p1.jpeg',
			    	img:'p2.jpeg',
			    	title: 'Tom Riddle Meets Albus Dumbledore'
			    },
			    interval: null,
	      	}
	    },



	    methods: {

	    	previous() {
		    	if(this.posts.length <= this.activeIndex) {
		    	  	EventBus.$emit('playagain',false);
		    	}

	    		if(this.activeIndex > 0) {
	    			this.activeIndex--;
	    		} 
	    		// Autoplay button reset
	    		this.completedSteps = 0;

	    		// progressbar
	    		this.progressPercent();

	    		// clear interval
	    		this.clrInterval()
	    	},

	    	center() {
	    	  //autoplay slider
	    	  if(this.posts.length <= this.activeIndex) {
	    	  	this.activeIndex = 0;
	    	  	this.progress = 0;
	    	  }

		      const it = this.posts[Symbol.iterator]();
		      this.interval = setInterval(() => { 
		        const next = it.next();
		        if (!next.done) {
		          this.activeIndex++;
		          this.progressPercent();
		        } else {
					setTimeout(() => { 
						this.completedSteps = 10,
	    	  			EventBus.$emit('playagain',true);
					}, 2000)
		          clearInterval(this.interval);
		        }
		      }, 1000)
 
	    	},	

	    	next() {
	    		if(this.activeIndex == this.posts.length-1) {
	    			EventBus.$emit('playagain',true);

					setTimeout(() => { 
						// Autoplay button time
						this.completedSteps = 10
					}, 1000)
	    		}

	    		if(this.activeIndex < this.posts.length) {
	    			this.activeIndex++;
	    		}
	    		this.progressPercent();

	    		// clear interval
	    		this.clrInterval()
	    	},

	    	progressPercent() {
	    		if(this.activeIndex >= 0 && this.activeIndex <= this.posts.length) {
	    		    var result = this.activeIndex / this.posts.length;
	    			this.progress = result * 100;		
	    		}
	    	},

	    	seriescancel() {
	    		EventBus.$emit('seriesCancel',true);
				setTimeout(() => { 
					if(this.nextAutoPlay==true) {
						EventBus.$emit('nextSeriesPlay',true);
					}
				}, 5000)
	    	},

	    	isOnboarding() {
	    		this.onboarding = localStorage.getItem('onboarding');
	    	},

	    	clrInterval() {
	    		if(this.interval!=null){
	    			clearInterval(this.interval);
	    		}
	    	},


	    },

	    created() {
	    	// key post details slide control
		    document.onkeydown = evt => {
		      evt = evt || window.event;
		      if (evt.keyCode == 37) {
		        this.previous();
		      }  
		      if(evt.keyCode == 39) {
		        this.next();
		      }
		      if(evt.keyCode == 32) {
		        this.center();
		      }
		    };

	        EventBus.$on('play', data => {
	        	// Playagain 
	            this.activeIndex=data;
	            this.progress=0;
	            //this.center()
	            // autoplay btn reset
	            this.completedSteps=0;
	        });

	        EventBus.$on('onboarding', data => {
	            this.onboarding=data;
	        });

	        EventBus.$on('nextplay', data => {
	            this.nextAutoPlay=data;
	        });

	        // autploay
	        EventBus.$on('autoplay', data => {
	        	if(data==true) {
	        		this.center();
	        	} else {
	        	  clearInterval(this.interval);
	        	}
	        });

	        this.isOnboarding();
	    },

		components: {
		    RadialProgressBar
		}
    }

</script>
